(function () {
	const PERSONALISED_GALLERY_SELECTOR = '.personalised-prod-v2 media-gallery';
	const PERSONALISED_MOBILE_QUERY = '(max-width: 1023.98px)';

	function onReady(callback) {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', callback, { once: true });
			return;
		}

		callback();
	}

	function addMediaQueryListener(mediaQueryList, callback) {
		if (typeof mediaQueryList.addEventListener === 'function') {
			mediaQueryList.addEventListener('change', callback);
			return;
		}

		if (typeof mediaQueryList.addListener === 'function') {
			mediaQueryList.addListener(callback);
		}
	}

	function schedule(callback) {
		if (typeof window.requestAnimationFrame === 'function') {
			window.requestAnimationFrame(callback);
			return;
		}

		window.setTimeout(callback, 0);
	}

	function patchGallery(gallery) {
		if (!gallery || gallery.__ppv2GalleryPatched) return;
		if (!gallery.elements || !gallery.sliderOptions || !gallery.thumbsOptions) {
			schedule(() => patchGallery(gallery));
			return;
		}

		const personalisedMobileMql = window.matchMedia(PERSONALISED_MOBILE_QUERY);
		const themeMobileMql = window.matchMedia(window.FoxTheme?.config?.mediaQueryMobile || 'screen and (max-width: 767px)');
		const originalDestroySlider = gallery.destroySlider;

		function ensureElements(instance) {
			if (!instance.elements) {
				instance.elements = {};
			}

			instance.elements.viewer = instance.elements.viewer || instance.querySelector('[id^="GalleryViewer"]');
			instance.elements.mediaList = instance.elements.mediaList || instance.querySelector('[id^="Slider-Gallery"]');
			instance.elements.thumbnails = instance.elements.thumbnails || instance.querySelector('[id^="GalleryThumbnails"]');
		}

		function hasThumbsWired(instance) {
			return !!(
				instance.sliderInstance &&
				typeof instance.sliderInstance === 'object' &&
				instance.sliderInstance.slider &&
				instance.sliderInstance.slider.thumbs &&
				instance.sliderInstance.slider.thumbs.swiper
			);
		}

		gallery.destroySlider = function destroyPersonalisedSlider() {
			if (typeof this.thumbsInstance === 'object' && this.thumbsInstance.slider) {
				this.thumbsInstance.slider.destroy();
			}

			this.thumbsInstance = false;
			this.__ppv2SlideChangeBound = false;
			originalDestroySlider.call(this);
		};

		gallery.handleSlideChange = function handleSlideChangeSafe() {
			if (!this.sliderInstance || !this.sliderInstance.slider || this.__ppv2SlideChangeBound) return;

			this.sliderInstance.slider.on('realIndexChange', (swiper) => {
				const { slides, activeIndex, thumbs } = swiper;
				const thumbSwiper = thumbs && thumbs.swiper;

				if (thumbSwiper && typeof thumbSwiper.slideTo === 'function') {
					thumbSwiper.slideTo(activeIndex);
				}

				if (slides[activeIndex]) {
					this.playActiveMedia(slides[activeIndex]);

					const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
					this.toggleSliderDraggableState(!isModelMediaType);
				}
			});

			this.__ppv2SlideChangeBound = true;
		};

		gallery.__ppv2GalleryPatched = true;

		gallery.updateMediaLayout = function updatePersonalisedMediaLayout() {
			ensureElements(this);

			const shouldUseSlider = personalisedMobileMql.matches || this.enableDesktopSlider;
			const thumbsEligible = (this.enableDesktopSlider || this.enableMobileThumbnails) && !!this.elements.thumbnails;

			if (shouldUseSlider) {
				this.destroyGridClickHandler();

				if (typeof this.sliderInstance === 'object' && thumbsEligible && !hasThumbsWired(this)) {
					this.destroySlider();
				}

				this.initSlider();
				return;
			}

			this.destroySlider();
			if (this.mediaLayout === 'grid-mix') {
				this.initGridClickHandler();
			}
		};

		const applyLayout = () => schedule(() => gallery.updateMediaLayout());

		addMediaQueryListener(personalisedMobileMql, applyLayout);
		addMediaQueryListener(themeMobileMql, applyLayout);
		applyLayout();
	}

	customElements.whenDefined('media-gallery').then(() => {
		onReady(() => patchGallery(document.querySelector(PERSONALISED_GALLERY_SELECTOR)));
	});
})();
